import React from "react";
import { Flex, Box } from "rebass";
import styled from "styled-components";
import { partition } from "lodash";
import { formatDate } from "../utils";

const Container = styled.div`
  p {
    margin: 0;
  }
  line-height: 1.3;
`;

const BorderedFlex = styled(Flex)`
  border-top: 1px dotted black;
  &:last-child {
    border-bottom: 1px dotted black;
  }
  padding-top: 1%;
  padding-bottom: 1%;
`;

const DataRow = ({
  label,
  value,
  isHTML,
  wrap = false,
  ratio = [1, 3.5],
  border = true,
  mb = 12
}) => {
  const labelProps = wrap
    ? {
        style: {
          fontWeight: "bold"
        },
        w: 1
      }
    : {
        flex: ratio[0]
      };

  const valueProps = wrap
    ? {
        w: 1
      }
    : {
        flex: ratio[1],
        pl: 10
      };

  const Wrapper = border ? BorderedFlex : Flex;
  return (
    <Wrapper wrap={wrap} mb={wrap ? mb : 0}>
      <Box {...labelProps}>{label}</Box>
      {isHTML ? (
        <Box {...valueProps} dangerouslySetInnerHTML={{ __html: value }} />
      ) : (
        <Box {...valueProps}> {value} </Box>
      )}
    </Wrapper>
  );
};

const isDate = d => d.itemType === "date";

// there is no way to define a period in the dato cms, so it is done by specifying multiple dates
// this function takes the array containing the dates and returns a new one
// where the date objects are merged into a single one
// so that they can be displayed as a single row
function transformDates(data) {
  const dateIndex = data.findIndex(isDate);
  if (dateIndex === -1) {
    return data;
  }

  const [left, right] = partition(data, d => data.indexOf(d) < dateIndex);
  const [dates, nonDates] = partition(right, isDate);

  const result = left
    .concat({ itemType: "dates", values: dates })
    .concat(nonDates);
  return result;
}

export default ({ data: rawd, layoutProps }) => {
  const { ratio, mb, wrap, border } = layoutProps;
  const data = transformDates(rawd);
  const rows = data
    .filter(d => !isDate(d))
    .map(d => {
      switch (d.itemType) {
        case "key_value_pair":
          return {
            label: d.label,
            value: d.value,
            isHTML: true
          };

        case "dates":
          return {
            label: "Datum",
            value: d.values.map(({ value }) => formatDate(value)).join(" - ")
          };

        case "location": {
          const { coordinates: { latitude, longitude }, displayName } = d;
          const value = (
            <a
              target="__blank"
              href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
            >
              {displayName}
            </a>
          );
          return {
            label: "Locatie",
            value
          };
        }

        default:
          return {
            label: "",
            value: ""
          };
      }
    })
    .map((props, i) => (
      <DataRow
        key={i}
        border={border}
        mb={mb}
        ratio={ratio}
        wrap={wrap}
        {...props}
      />
    ));

  return <Container>{rows}</Container>;
};



// WEBPACK FOOTER //
// ./src/components/metadata.js